import SubcontractGoodReceiptDetail from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptDetail';

export default class SubcontractGoodReceiptDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.subcontractGoodReceiptId  = '';
		this.subcontractGoodReceiptSubcontractGoodReceiptNumber = '';
		this.id = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.isComplete = false;
		this.caseQty = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			subcontractGoodReceiptId : '0',
			subcontractGoodReceiptSubcontractGoodReceiptNumber : '0',
			id : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			isComplete : '0',
			caseQty : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}